/**
 * /frontend/src/features/analytics/components/appointments/PopularTimeSlotsChart.js
 */

import React from 'react';
import ChartContainer from '../shared/ChartContainer';
import ComparisonBarChart from '../charts/ComparisonBarChart';

/**
 * Popular time slots chart.
 * @param {{data:Array<{slotLabel:string,bookingCount:number}>}} props
 * @returns {JSX.Element}
 */
const PopularTimeSlotsChart = ({ data }) => (
  <ChartContainer title="Popular Time Slots" subtitle="Most booked slots">
    <ComparisonBarChart data={data} xKey="slotLabel" yKey="bookingCount" />
  </ChartContainer>
);

export default PopularTimeSlotsChart;

